import React from 'react';
import Panel from "../panels/Panel";
import SignalLevelsForm from "./SignalLevelsForm";
import PropTypes from "prop-types";


const SignalLevelsPanel = (props) => {
  const {
    workOrderActions,
    orderId,
    techId,
    handleTextValueChange,
    handleCheckStateChange,
    dropdownOptions,
    sections,
    signalLevelsStore,
    signalLevelsDetails,
    channels
  } = props;

  return (
    <Panel
      key="signal-level-panel"
      hasDetails={true}
      showRefreshButton={false}
      paddingLeft="0"
      paddingRight="0"
      header="Signal Levels"
      detailKey="signalLevels"
    >
      <SignalLevelsForm
        workOrderActions={workOrderActions}
        orderId={orderId}
        handleTextValueChange={handleTextValueChange}
        handleCheckStateChange={handleCheckStateChange}
        dropdownOptions={dropdownOptions}
        sections={sections}
        signalLevelsStore={signalLevelsStore}
        signalLevelsDetails={signalLevelsDetails}
        channels={channels}
      />
    </Panel>
  );
};

SignalLevelsPanel.propTypes = {
  orderCloseDetails: PropTypes.object,
  workOrderActions: PropTypes.object,
  orderId: PropTypes.string,
  techId: PropTypes.string
};

export default SignalLevelsPanel;



// WEBPACK FOOTER //
// ./src/components/signal-levels/SignalLevelsPanel.js